// extracted by mini-css-extract-plugin
module.exports = {"root":"CategorySection_root__JJplY","title":"CategorySection_title__l23MT","links":"CategorySection_links__wEZzh"};